import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      // TODO: Implémenter l'API newsletter
      setSubscribed(true);
      setTimeout(() => {
        setSubscribed(false);
        setEmail('');
      }, 3000);
    }
  };

  const navLinks = [
    { to: '/', label: 'Accueil', icon: '🏠' },
    { to: '/exposes', label: 'Exposés', icon: '📝' },
    { to: '/ramadan', label: 'Ramadan', icon: '🌙' },
    { to: '/events', label: 'Événements', icon: '📅' },
    { to: '/galerie', label: 'Galerie', icon: '📸' },
    { to: '/bibliotheque', label: 'Bibliothèque', icon: '📚' },
    { to: '/mediatheque', label: 'Médiathèque', icon: '🎵' },
  ];

  return (
    <footer className="bg-gradient-to-br from-green-900 via-green-800 to-green-900 text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* About Section */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="bg-white bg-opacity-20 rounded-xl p-3 backdrop-blur-sm">
                <span className="text-3xl">🕌</span>
              </div>
              <div>
                <h3 className="text-2xl font-bold">Hanafia</h3>
                <p className="text-green-200 text-sm">Dahira Université de Thiès</p>
              </div>
            </div>
            <p className="text-green-100 mb-6 leading-relaxed">
              Plateforme Hanafia - Une plateforme complète pour découvrir nos exposés hebdomadaires, 
              événements de la mosquée, bibliothèque complète et médiathèque audio. 
              Rejoignez notre communauté pour enrichir votre connaissance.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full p-3 transition-all transform hover:scale-110">
                <span className="text-xl">📘</span>
              </a>
              <a href="#" className="bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full p-3 transition-all transform hover:scale-110">
                <span className="text-xl">📷</span>
              </a>
              <a href="#" className="bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full p-3 transition-all transform hover:scale-110">
                <span className="text-xl">🐦</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-yellow-300">Navigation rapide</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link 
                    to={link.to} 
                    className="text-green-100 hover:text-yellow-300 transition-colors flex items-center space-x-2 group"
                  >
                    <span className="group-hover:translate-x-1 transition-transform">{link.icon}</span>
                    <span>{link.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-yellow-300">Newsletter</h4>
            <p className="text-green-100 mb-4 text-sm">
              Restez informé de nos dernières activités et événements
            </p>
            {subscribed ? (
              <div className="bg-green-700 rounded-lg p-4 text-center">
                <span className="text-2xl mb-2 block">✅</span>
                <p className="text-sm">Merci pour votre inscription !</p>
              </div>
            ) : (
              <form onSubmit={handleSubscribe} className="space-y-3">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Votre email"
                  required
                  className="w-full px-4 py-3 rounded-lg bg-white bg-opacity-10 border border-white border-opacity-20 text-white placeholder-green-200 focus:outline-none focus:ring-2 focus:ring-yellow-300 focus:border-transparent"
                />
                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-green-900 font-bold py-3 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
                >
                  S'abonner
                </button>
              </form>
            )}
            <div className="mt-6 space-y-2 text-sm text-green-200">
              <p className="flex items-center space-x-2">
                <span>📍</span>
                <span>Université de Thiès, Sénégal</span>
              </p>
              <p className="flex items-center space-x-2">
                <span>📧</span>
                <span>dahira@ut.sn</span>
              </p>
              <p className="flex items-center space-x-2">
                <span>🕌</span>
                <span>Mosquée Université</span>
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-green-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-green-200 text-sm">
              &copy; {new Date().getFullYear()} Dahira Université de Thiès. Tous droits réservés.
            </p>
            <div className="flex space-x-6 text-sm text-green-200">
              <Link to="#" className="hover:text-yellow-300 transition-colors">Mentions légales</Link>
              <Link to="#" className="hover:text-yellow-300 transition-colors">Politique de confidentialité</Link>
              <Link to="#" className="hover:text-yellow-300 transition-colors">Contact</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

